export const REFERRAL_KEY = 'referral-source';
export const WINDFALL_REFERRAL_VALUE = 'windfall';
export const WINDFALL_LOCAL_STORAGE_KEY = 'windfall';

export function isWindfallReferral() {
    const query = new URLSearchParams(window.location.search);
    const referralSource = query.get(REFERRAL_KEY);

    return referralSource === WINDFALL_REFERRAL_VALUE;
}
